import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";

function ClubAndCell() {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  const clubs = [
    { id: 1, name: "Vision Hub",            head: "Mrs. Manisha Baxla", members: ["Navin Kumar", "Neha Gupta", "Pawan Kumar"] },
    { id: 2, name: "Cyber Club",            head: "Dr. Manish Kumar",   members: ["Shivraj Kumar", "Aditya Kumar"] },
    { id: 3, name: "Code Club",             head: "Dr. Santosh Kumar Singh",  members: ["Rajiv Ranjan", "Monika Kumari"] },
    { id: 4, name: "Eco and Swachh Bharat", head: "Dr. Santosh Kumar Srivastava",    members: ["Diksha Kumari", "Tanisha Singh", "Rajat Kumar"] },
    { id: 5, name: "English Literary Club", head: "Mr. Rahul Prasad",    members: ["Aditya Kumar", "Banty Kumar", "Neha Kumari"] },
    { id: 6, name: "Game Development Club", head: "Mr. Prabhat Kumar",   members: ["Praveen Kumar Verma", "Chanchal Kumari", "Shivankit Agrawal"] },
    { id: 7, name: "Photography Club",      head: "Mr. Ashutosh Kumar Singh", members: ["Sonam Kumari", "Arti Kumari", "Ayush Anand"] },
    { id: 8, name: "Skill Development Club", head: "Dr. Ashish Kumar Saha", members: ["Sheshav Anand", "Shubham Kumar", "Heena Perween"] },
  ];

  const cells = [
    { id: 1, name: "Entrepreneurship Cell",          head: "Dr. Manish Kumar",          members: ["Pankaj Kumar", "Goutam Kumar", "Om Kumar Sharma"] },
    { id: 2, name: "Higher Education Cell",          head: "Mrs. Manisha Baxla",        members: ["Shailesh Kumar", "Nisha Priya", "Swati Kumari"] },
    { id: 3, name: "NCC",                            head: "Mr. Rahul Prasad",          members: ["Lavkesh Kumar Yadav", "Anshu Kumari", "Omshiv Kumar Yadav"] },
    { id: 4, name: "NSS",                            head: "Mr. Prabhat Kumar",         members: ["Shristy Kumari", "Shakil Raj", "Ayush Kumar"] },
    { id: 5, name: "IPR",                            head: "Dr. Santosh Kumar Singh",   members: ["Rounak Kumar", "Surbhi Kumari", "Akash Kumar"] },
    { id: 6, name: "Women Empowerment Cell ", head: "Mrs. Manisha Baxla",        members: ["Pinki Kumari", "Farhat Afreen", "Monika Kumari"] },
    { id: 7, name: "UHV Cell",                       head: "Dr. Santosh Kumar Srivastava", members: ["Badal Mehta", "Naman Kumar Rana", "Rajan Kumar Gupta"] },
    { id: 8, name: "Institution Industry Cell",      head: "Dr. Ashish Kumar Saha", members: ["Dr. Santosh Kumar Srivastava", "Mr. Santosh Kumar Singh", "Dr. Anupam Anand", "Mr. Birju Kumar", "Mr. Amir Kumar Soni"], pdf: "/docs/iic cell.pdf" },
    { id: 9, name: "Placement Cell",                 head: "Prof. Ashish Kumar Saha (Chairman) & Dr. Santosh Kumar Srivastava (Convenor)", members: ["Mr. Santosh Kumar Singh", "Dr. Manish Kumar", "Mr. Ashutosh Kumar Singh", "Mr. Prabhat Kumar", "Mr. Rahul Prasad", "Mrs. Manisha Baxla", "Mr. Rajiv Ranjan", "Mr. Navin Kumar"], pdf: "/docs/placementcell.pdf" },
  ];

  return (
    <>
      <Helmet>
        <title>VBU - Clubs and Cells</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Clubs and Cells</h1>
        </div>

        <div className="Desc" data-aos="fade-up" style={{ display: 'flex', flexDirection: 'column', gap: '40px', padding: '0 20px 40px 20px' }}>
          
          {/* Clubs Section */}
          <div className="TableSection">
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '600px', border: '1px solid #ddd' }}>
                <thead>
                  <tr style={{ backgroundColor: '#4a82c3', color: '#fff' }}>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', width: '8%' }}>S. No.</th>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', width: '25%' }}>Club Names</th>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', width: '22%' }}>Head</th>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd' }}>Members</th>
                  </tr>
                </thead>
                <tbody>
                  {clubs.map((club, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                       <td style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#333' }}>{club.id}</td>
                       <td style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#333', fontWeight: '500' }}>{club.name}</td>
                       <td style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#1a237e', fontWeight: '600' }}>{club.head}</td>
                       <td style={{ padding: '15px', borderBottom: '1px solid #ddd', color: '#555' }}>{club.members.join(', ')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Cells Section */}
          <div className="TableSection">
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '600px', border: '1px solid #ddd' }}>
                <thead>
                  <tr style={{ backgroundColor: '#4a82c3', color: '#fff' }}>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', width: '8%' }}>S. No.</th>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', width: '25%' }}>Cell Names</th>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', width: '22%' }}>Head</th>
                    <th style={{ padding: '15px', borderBottom: '1px solid #ddd' }}>Members</th>
                  </tr>
                </thead>
                <tbody>
                  {cells.map((cell, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                      <td style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#333' }}>{cell.id}</td>
                      <td style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#333', fontWeight: '500' }}>
                        {cell.name}
                        {cell.pdf && (
                          <a href={cell.pdf} target="_blank" rel="noreferrer" style={{ marginLeft: '10px', color: '#d32f2f', fontSize: '0.8rem', fontWeight: '600', textDecoration: 'underline' }}>
                            (View PDF)
                          </a>
                        )}
                      </td>
                      <td style={{ padding: '15px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#1a237e', fontWeight: '600' }}>{cell.head}</td>
                      <td style={{ padding: '15px', borderBottom: '1px solid #ddd', color: '#555' }}>{cell.members.join(', ')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default ClubAndCell;
